import { Database } from "react-feather";
import { Btn, H6, LI, ProgressBar, UL } from "../../../../AbstractElements";
import { Storage } from "../../../../Constants/Constants";

const StoragePlan = () => {
  return (
    <UL className="simple-list">
      <LI>
        <Btn outline color="primary"><Database />{Storage}</Btn>
      </LI>
      <LI>
        <div className="m-t-15">
          <ProgressBar color="primary" style={{ height: "8px" }} value={25} className="mb-3" />
          <H6 className="f-w-500">{"25 GB of 100 GB used"}</H6>
        </div>
      </LI>
    </UL>
  );
};

export default StoragePlan;
